import { Injectable } from '@angular/core';

import { VirtualCompetitionGroupItem } from '@frontend/sports/common/core/data-access/sport-model';

import { FixtureList } from '../event-list-shared/sport/competitions/competition.models';

@Injectable({ providedIn: 'root' })
export class CompetitionListSeoService {
    private realCompetitionId: number | undefined;

    getRealCompetitionId(): number | undefined {
        return this.realCompetitionId;
    }

    saveRealCompetitionId(id: number | undefined): void {
        this.realCompetitionId = id;
    }

    storeRealCompetitionId(fixtureList: FixtureList | undefined): void {
        this.realCompetitionId = undefined;
        const virtualCompetition = fixtureList && fixtureList.virtualCompetition;
        if (virtualCompetition) {
            const virtualGroupId = fixtureList.params && fixtureList.params.virtualCompetitionGroup;
            const virtualGroup =
                virtualCompetition.children &&
                (virtualCompetition.children.find((group) => group.id === virtualGroupId) as VirtualCompetitionGroupItem | undefined);
            this.realCompetitionId = virtualGroup ? virtualGroup.siblings[0] : virtualCompetition.siblings[0];
        }
    }
}
